import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useUtmTaxonomyStore } from '@/store/utm-taxonomy-store';
import UtmGroupList from '@/components/utm/admin/groups/UtmGroupList';
import UtmGroupForm from '@/components/utm/admin/groups/UtmGroupForm';

const UtmGroupsPage = () => {
  const { fetchTaxonomy } = useUtmTaxonomyStore();

  useEffect(() => {
    fetchTaxonomy();
  }, [fetchTaxonomy]);

  return (
    <Routes>
      <Route index element={<UtmGroupList />} />
      <Route path="new" element={<UtmGroupForm />} />
      <Route path=":id/edit" element={<UtmGroupForm />} />
    </Routes>
  );
};

export default UtmGroupsPage;
